export default __webpack_public_path__ + "static/media/9.d69ae4fd.jpeg";